import React from 'react';

// Builds the `trigger` render prop for the policy-number Menu dropdown.
export const policyMenuTrigger = (policyNumber) => ({ open, toggle }) => (
  <button
    type="button"
    className={`w-full text-left flex justify-between items-center font-bold text-base-content ${open ? " dl-select-trigger--open" : ""}`}
    onClick={toggle}
  >
    <span>{policyNumber}</span>
    <i className="icofont-simple-down"></i>
  </button>
);
